import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import AgencyIcon from "../components/Icons/Agency_icon.vue";

Vue.use(Vuetify, {
  theme: {
    primary: "#e53d3d",
    secondary: "#424242",
    accent: "#82B1FF",
    error: "#FF5252",
    info: "#2196F3",
    success: "#4CAF50",
    warning: "#FFC107"
  },
  options: {
    customProperties: true
  },
  icons: {
    agency: {
      component: AgencyIcon
    }
  },
  iconfont: "md"
});
